export default class Benefiting {
  constructor ({ id = null, name = null, reference = null, page_id = null, page_slug = null } = {}) {
    this.id = id
    this.name = name
    this.reference = reference
    this.page_id = page_id
    this.page_slug = page_slug
  }

  get to_database () {
    return {
      id: this.id
    }
  }

  get to_tamaro () {
    return {
      stored_benefiting_id: this.id,
      stored_benefiting_name: this.name,
      stored_benefiting_reference: this.reference
    }
  }

  get to_tamaro_automation () {
    return {
      benefiting_reference: this.reference
    }
  }
}
